import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { Panel } from './components/Panel'
import { DEFAULT_PANEL_WIDTH, PANEL_TRANSITION_DURATION } from './components/Panel/const'
import { PanelProvider } from './provider'

type ResponsivePageWithPanelProps = React.ComponentProps<typeof ResponsivePage.Body> & {
  panelWidth?: number
  panelTitle: string
  onOpen?: () => void
}

export const ResponsivePageWithPanel = ({ ...props }: ResponsivePageWithPanelProps) => {
  const [openBodyPanel, setOpenBodyPanel] = useState(false)
  const [bodyPanelContent, setBodyPanelContent] = useState<React.ReactNode>(null)

  const panelWidth = props.panelWidth ?? DEFAULT_PANEL_WIDTH

  // TODO: This is a hack to get the height of the main content when elements are fixed to the top of the page.
  // We should find a better way to do this.
  const mainContent = document.getElementById('content')
  const mainContentTop = mainContent?.getBoundingClientRect().top

  useEffect(() => {
    if (openBodyPanel) {
      props.onOpen?.()
    }
  }, [openBodyPanel])

  return (
    <ResponsivePage.Body {...props} variant="fullscreen" height="full">
      <PanelProvider
        open={openBodyPanel}
        setOpen={setOpenBodyPanel}
        setContent={setBodyPanelContent}
      >
        <Box flexDirection="row" width="full" height="full" alignItems="stretch">
          <Box
            overflowY="auto"
            padding="s24"
            style={{
              maxHeight: '100%',
              width: openBodyPanel ? `calc(100% - ${panelWidth}px)` : '100%',
              transition: `width ${PANEL_TRANSITION_DURATION}ms ease-in-out`,
            }}
            data-scroll-container
          >
            {props.children}
          </Box>
          {openBodyPanel && (
            <Box
              {...(mainContentTop && mainContentTop > 0
                ? { style: { height: `calc(100% - ${mainContentTop}px)` } }
                : { height: 'full' })}
            >
              <Panel
                title={props.panelTitle}
                width={props.panelWidth}
                setOpen={setOpenBodyPanel}
                content={bodyPanelContent}
              />
            </Box>
          )}
        </Box>
      </PanelProvider>
    </ResponsivePage.Body>
  )
}
